import script from "./CustomerRevenueManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerRevenueManagement.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerRevenueManagement.vue?vue&type=style&index=0&id=1af4f2ee&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af4f2ee"]])

export default __exports__